import { Line } from 'react-chartjs-2';
import 'chartjs-adapter-date-fns';
import zoomPlugin from 'chartjs-plugin-zoom';
import moment from "moment";

import {
    Chart as ChartJS,
    CategoryScale, 
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Legend,
    TimeScale,
    TimeSeriesScale,
    Filler,
    Tooltip,
} from 'chart.js';


ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Legend,
    TimeScale,
    TimeSeriesScale,
    Filler,
    Tooltip,
    zoomPlugin,
);
  
export const LineChartDetailsCardReport = ({datasets, labels, minimumFractionDigits = 0, key, type, local, sensorName}) => {
    
    const options = {
        
        type: 'line',
        maintainAspectRatio: false,
        responsive: true,
        animation: false,
        aspectRatio: 1,
        showTooltips: true,
        elements: {
            point:{
                radius: 0,
                
            }
        },
        transitions: {
            zoom: {
              animation: {
                duration: 0
              }
            }
          },
        plugins: {
            tooltip: {
                enabled: true,
                backgroundColor: 'rgb(255,255,255)',
                titleColor: '#000000',
                bodyColor: '#000000',
                caretPadding: 100,
                position: 'nearest',
                usePointStyle: true,
                borderColor: 'rgb(106, 106, 106)',
                borderWidth: 0.5,
                callbacks: {
                    title: function(context) {
                        
                        if(type !== "all"){
                            context[0].label = moment(context[0].label, "MMM DD, YYYY, h:mm:ss a").format("DD/MM/YY HH:mm:ss"); 
                            if (context.length > 0 && context.length < 2){
                                context[0].formattedValue = "";
                            } else if (context.length === 2){
                                context[0].formattedValue = "";
                                context[1].formattedValue = "";
                            } else if (context.length === 3){
                                context[0].formattedValue = "";
                                context[1].formattedValue = "";
                                context[2].formattedValue = "";
                            } else if (context.length > 3){
                                context[0].formattedValue = "";
                                context[1].formattedValue = "";
                                context[2].formattedValue = "";
                                context[3].formattedValue = "";
                            }
                        }else{
                            context[0].label = moment(context[0].label, "MMM DD, YYYY, h:mm:ss a").format("DD/MM/YY HH:mm:ss"); 
                        }
                        
                    },
                    label:function(context){

                        if(context.formattedValue.includes('.')){

                        }else{
                            const value = parseFloat(context.formattedValue.replace(',', '.'));
                            if(context.dataset.label === ""){
                             context.formattedValue = "";
                            } else if(context.formattedValue.length < 7){
                                const formattedValue = isNaN(value) ? context.formattedValue : value.toFixed(2);
                                context.formattedValue = formattedValue;
                            }
                        }

                        
                    }
                }
              },
            legend: {
                position: 'top',
                labels: {
                    usePointStyle: true,
                    generateLabels: function(chart) {
                      const defaultLabels = ChartJS.defaults.plugins.legend.labels.generateLabels(chart);
                      const updatedLabels = defaultLabels.map(label => {
                        
                        if (label.text === '') {
                          label.lineCap = 'butt';
                          label.fillStyle = 'rgba(0, 0, 0, 0)';
                          label.lineWidth = 0;      
                          label.onClick = () => {};             
                        }else if(label.text === "Temp P"){
                            label.padding = 10;
                            label.textAlign = 'center';
                            label.textBaseline = 'middle';
                            label.fontColor = 'rgba(246, 167, 104)';                           
                        } else if (label.text === "Temp S"){
                            label.padding = 10;     
                            label.textAlign = 'center';
                            label.textBaseline = 'middle';
                            label.fontColor =  'rgba(246, 167, 104)';   
                        } else if (label.text === "Temp E"){
                            label.padding = 10;
                            label.textAlign = 'center';
                            label.textBaseline = 'middle';
                            label.fontColor = 'rgba(255, 62, 62)';
                        } else if (label.text === "Temp M"){
                            label.padding = 10;
                            label.textAlign = 'center';
                            label.textBaseline = 'middle';
                            label.fontColor = 'rgb(255, 112, 0)';   
                        } else if (label.text === "Umid P"){
                            label.padding = 10;
                            label.textAlign = 'center';
                            label.textBaseline = 'middle';
                            label.fontColor = 'rgb(122, 140, 255)';   
                        } else if (label.text === "Umid S"){
                            label.padding = 10;
                            label.textAlign = 'center';
                            label.textBaseline = 'middle';
                            label.fontColor = 'rgb(122, 140, 255)';   
                        } else if (label.text === "Umid S"){
                            label.padding = 10;
                            label.textAlign = 'center';
                            label.textBaseline = 'middle';
                            label.fontColor = 'rgb(122, 140, 255)';   
                        } else if (label.text === "Umid M"){
                            label.padding = 10;
                            label.textAlign = 'center';
                            label.textBaseline = 'middle';
                            label.fontColor = 'rgb(0, 35, 255)';   
                        } else if (label.text === "CO2"){
                            label.padding = 10;                            
                            label.textAlign = 'center';
                            label.textBaseline = 'middle';
                            label.fontColor = 'rgba(0, 179, 52, 0.7)';   
                        } else if (label.text === "Ar-Condicionado Ligado"){
                            label.padding = 10;
                            label.textAlign = 'center';
                            label.textBaseline = 'middle';
                            label.fontColor = 'rgba(220, 120, 0)';
                        } else if(label.text === "Porta Fechada"){
                            label.padding = 10;
                            label.textAlign = 'center';
                            label.textBaseline = 'middle';
                            label.fontColor = 'rgb(12, 100, 0)';
                        } else if(label.text === "Limite Inf" || label.text === "Limite Sup"){
                            label.text = '';
                        }else if (label.text === "Porta Aberta" || label.text === "Ar Condicionado Desligado"){
                            label.text = '';
                        }
                        return label;
                      });
          
                      return updatedLabels;
                    },
                    font:{
                        size: 20,
                        family:'Arial',
                        weight: 'bold'
                    }
                  }
                
            },
            title: {
                display: false,
            },

            zoom: {
                enabled: sensorName === 'portAndAcFarm' ? false : true,
                mode: 'xy',
                zoom: {
                    wheel: {
                        enabled: sensorName === 'portAndAcFarm' ? false : true,
                    },
                    pinch: {
                        enabled: sensorName === 'portAndAcFarm' ? false : true,
                    },
                    drag: {
                        enabled: sensorName === 'portAndAcFarm' ? false : true,
                        backgroundColor: 'rgba(255, 99, 132, 0.2)',
                        borderColor: 'rgb(255, 99, 132)',
                        borderWidth: 1,
                        modifierKey: 'ctrl'
                    },
                },
           
              }
                
        
        },

        hover: {
            mode: "nearest",
            intersect: true,
        },
        interaction: {
          mode: "index",
          intersect: false,
        },

        scales: {
            x: {
                type:'time',
                time: {
                    
                    unit: 'minute',

                },
                grid: {
                    display: type === "all" ? true : false,
                    drawOnChartArea: type === "all" ? false : false,
                    drawTicks: type === "all" ? false : false,
                    offset: false,
                    lineWidth: 0.1,

                },
                border: {
                    display: false
                },
                ticks: {
                    source: 'auto',
                    display: type === "all" ? true : false,
                    maxRotation: 90,
                    minRotation: 90,
                    autoSkip: true,
                    beginAtZero: true,

                    font:{
                        size : 12
                      },
                    color: "rgb(0, 0, 0)",
                    stepSize: 2,
                 
                    callback: (value, index, values) => {
                        const formattedDate = moment(value).format("DD/MM/YYYY HH:mm:ss");
                        return formattedDate;
                      },

                    
                },
            },
            y: {
                type: 'linear',
                display: true,
                position: 'left',
                offset: true,
                min: sensorName === 'temperatureFarm' ? -10 : sensorName === "humidityFarm" ? 0 : sensorName === "co2Farm" ? 0 :  sensorName === "portAndAcFarm" ? 0 : 0,
                max: sensorName === 'temperatureFarm' ? 45 : sensorName === "humidityFarm" ? 110 : sensorName === "co2Farm" ? 5000 : sensorName === "portAndAcFarm" ? 1 : 0,
                title:{
                    display: true,
                    text: sensorName === 'temperatureFarm' ? 'Temperatura interna [ºC]' : sensorName === "humidityFarm" ? "Umidade ]" : sensorName === "co2Farm" ? "Nível de CO2 [PPM]" : "", 
                    color: sensorName === 'temperatureFarm' ? 'rgba(255, 120, 0)' : sensorName === "humidityFarm" ? 'rgb(0, 121, 239)' : sensorName === "co2Farm" ? 'rgba(0, 138, 40)' : 'rgba(0, 138, 40)',
                    font:{
                        size: 20,
                        family:'Arial',
                        weight: 'bold'
                    }
                },
                border: {
                    display: sensorName === 'portAndAcFarm' ? false: true,
                },
                grid: {
                    drawOnChartArea: sensorName === 'portAndAcFarm' ? true: true,
                    display: sensorName === 'portAndAcFarm' ? true: true,
                    drawTicks: sensorName === 'portAndAcFarm' ? true: true,
                },              
                ticks: {
                    stepSize: sensorName === 'temperatureFarm' ? 5 : sensorName === "humidityFarm" ? 10 : sensorName === "co2Farm" ? 1000 : sensorName === 'portAndAcFarm' ? 1 : 1,
                    color: "black",
                    callback: function(val) {
                        if(type !== "all"){
                            if( val === 0){
                                return "A/C"
                            }else if( val === 1){
                                return "P"
                            }
                        }
                        return val.toLocaleString('pt-BR', { minimumFractionDigits });       
                      },
                      color:  function(context){
                        if(context.tick.label === "A/C"){
                            return "rgb(220, 120, 0)";
                        }else if (context.tick.label === "P"){
                            return "rgb(12, 100, 0)";
                        }else{
                            return "black";
                        }
                    },
                    font:{
                      size : 12
                    },
                    
                },

                
            },
            
        }
    };

    const data = {
        labels: labels ,
        datasets: datasets,
    };
    

    return (
       <Line id={`canvaID${sensorName}`} options={options} data={data}/>
    );
}